import React from "react";
import { Link } from "react-router-dom";
import {
  CurrencyDollarIcon,
  EnvelopeIcon,
  PhoneIcon,
  MapPinIcon,
  HeartIcon,
} from "@heroicons/react/24/outline";
import logo from "../assests/images/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Dashboard", href: "/dashboard" },
    { name: "Investors", href: "/investors" },
    { name: "Investment Schemes", href: "/schemes" },
    // { name: "Contract Stacking", href: "/contract-stacking" },
  ];

  const supportLinks = [
    { name: "Bulk Upload", href: "/bulk-upload" },
    { name: "Filter Investors", href: "/investors-filter" },
    { name: "Add Investor", href: "/investor-form" },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              {/* <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex items-center justify-center"> */}
              {/* <CurrencyDollarIcon className="h-6 w-6 text-white" /> */}
              {/* </div> */}
              <img
                src={logo}
                alt="Investors Portal Logo"
                className="w-20 rounded-lg object-cover"/>
              <div>
                <h3 className="text-xl font-bold">Investors Portal</h3>
                <p className="text-gray-400 text-sm">
                  Database Management System
                </p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Professional investment management platform designed to streamline
              investor data management, scheme tracking, and contract stacking
              operations with advanced security and comprehensive reporting
              features.
            </p>

            {/* Contact Info */}
            {/* <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <EnvelopeIcon className="h-5 w-5 text-blue-400" />
                <span className="text-gray-400">connect@uns</span>
              </div>
              <div className="flex items-center space-x-3">
                <PhoneIcon className="h-5 w-5 text-blue-400" />
                <span className="text-gray-400">+1 (555) 123-4567</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPinIcon className="h-5 w-5 text-blue-400" />
                <span className="text-gray-400">
                  Business District, Financial Center
                </span>
              </div>
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Tools & Support</h4>
            <ul className="space-y-2">
              {supportLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              <p>© {currentYear} Investors Portal. All rights reserved.</p>
            </div>

            <div className="flex items-center space-x-6 text-sm text-gray-400">
              {/* <Link
                to="/dashboard"
                className="hover:text-white transition-colors duration-200"
              >
                Privacy Policy
              </Link>
              <Link
                to="/dashboard"
                className="hover:text-white transition-colors duration-200"
              >
                Terms of Service
              </Link> */}
              <div className="flex items-center space-x-1">
                <span>Made with</span>
                <HeartIcon className="h-4 w-4 text-red-500" />
                <span>for secure investments</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Status Bar */}
      <div className="bg-gray-950 border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <div className="flex flex-col sm:flex-row justify-between items-center text-xs text-gray-500">
            <div className="flex items-center space-x-4 mb-2 sm:mb-0">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span>System Online</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                <span>Database Connected</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
                <span>API Active</span>
              </div>
            </div>
            <div>
              Last updated: {new Date().toLocaleDateString()} at{" "}
              {new Date().toLocaleTimeString()}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
